import { Flex, Box, TextField } from '@vibe/core';
import { Duplicate, Link, Embed } from '@vibe/icons';

type ShareBoxProps = {
  widgetId: string;
  introText?: React.ReactNode;
  hideBorder?: boolean;
  hideBackground?: boolean;
  isMenu?: boolean;
};

export function ShareBox({ widgetId, introText, hideBorder, hideBackground, isMenu }: ShareBoxProps) {
  const shareUrl = `${import.meta.env.VITE_WIDGETS_VIEWER_URL}/${widgetId}`;

  const embedCode = `<script src="${import.meta.env.VITE_WIDGETS_VIEWER_URL}/resizer/iframeResizer.min.js"></script>
<iframe id="widget-${widgetId}" src="${shareUrl}?type=embed" style="width:1px;min-width:100%;border:0;"></iframe>
<script>iFrameResize({ log: false }, '#widget-${widgetId}');</script>`;

  return (
    <Box
      marginTop={!isMenu ? 'large' : 'auto'}
      padding={!isMenu ? 'large' : 'medium'}
      paddingTop={!isMenu ? 'medium' : 'small'}
      border={hideBorder ? false : true}
      borderColor={hideBorder ? undefined : 'layoutBorderColor'}
      rounded={hideBorder ? undefined : 'small'}
      backgroundColor={hideBackground ? undefined : 'greyBackgroundColor'}
    >
      {introText}

      <Box marginBottom="small">
        <Flex gap={8} direction="column" align="start">
          <TextField
            readonly
            size="medium"
            title="Share link"
            value={shareUrl}
            labelIconName={Link}
            icon={Duplicate}
            onIconClick={() => {
              navigator.clipboard.writeText(shareUrl);
            }}
            className="CustomInput"
          />
        </Flex>
      </Box>
      <Box>
        <Flex gap={8} direction="column" align="start">
          <TextField
            readonly
            className="CustomInput"
            size="medium"
            title="Embed code"
            value={embedCode}
            labelIconName={Embed}
            icon={Duplicate}
            onIconClick={() => {
              navigator.clipboard.writeText(embedCode);
            }}
          />
        </Flex>
      </Box>
    </Box>
  );
}
